import React from "react";

function IconDesc({ className, icon, paraDesc, linkDesc, link ,customTutor=""}) {

  return (
    <div
      className={`${
        className || ""
      } icon-teacher-expiry d-flex align-items-center gap-1`}
    >
      {icon}
      <p className="p-0 m-0 d-inline-block gap-1">
        {paraDesc} {linkDesc && customTutor ? <span dangerouslySetInnerHTML={{__html: customTutor}}/> : <a href={link}>{linkDesc}</a>}
      </p>
    </div>
  );
}

export default IconDesc;
